import EggTypeWidgetContainer from "./EggTypeWidgetContainer";
export type { EggTypeApiResponse } from "./EggType";

export default EggTypeWidgetContainer;
